import React from 'react';
import styles from './DirectorInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';

const AdminInformations = ({ partner, onPartnerChange }) => {
    return (
        <Card className={styles.card} title="Informations de l'administrateur" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom de l'administrateur"
                    name="admin_contact_name"
                    type="text"
                    placeholder="Nom complet de l'administrateur"
                    value={partner?.admin_contact_name || ''}
                    onChange={onPartnerChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Email de l'administrateur"
                    name="admin_email"
                    type="email"
                    placeholder="admin@example.com"
                    value={partner?.admin_email || ''}
                    onChange={onPartnerChange}
                    required
                />
                <PhoneInput
                    className={styles.field}
                    label="Téléphone de l'administrateur"
                    name="phone"
                    id="admin_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={partner?.phone || ''}
                    onChange={onPartnerChange}
                    autoComplete="tel"
                />
            </div>
        </Card>
    );
};

export default AdminInformations;